export class ChangeEmail {
  id = '';
  name = '';
  token = '';
  email = '';
  newEmail = '';
}
